import React from "react";

import { framework_tool, component_tool } from "@/tool";
import Editor from './editor'
const { WizModal } = component_tool

//配置项
let componentName = "syncRelation";

const columns = (self) => {
  return [
    {
      name: "id",
    },
    {
      title: "来源",
      name: "channel",
      dataIndex: "channel",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      formItem: {
        type: 'select',
        initialValue: 'Zk'
      },
      dict: [
        {code: 'Zk', codeName: '企业号'}
      ]
    },
    {
      title: "关联类型",
      name: "dataType",
      dataIndex: "dataType",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      formItem: {
        type: 'select',
        initialValue: 'SyncPosition'
      },
      dict: [
        {code: 'SyncPosition', codeName: '普通岗位'},
        {code: 'SyncNewEnergyPosition', codeName: '新能源岗位'},
      ]
    },
    {
      title: "第三方岗位编码",
      name: "thirdId",
      dataIndex: "thirdId",
      searchItem: {},
      tableItem: {},
      formItem: {},
    },
    {
      title: "岗位id",
      name: "lmsId",
      dataIndex: "lmsId",
    },
    {
      title: "岗位名称",
      name: "attrs.name",
      dataIndex: "attrs.name",
      searchItem: {},
    },
    {
      title: "岗位名称",
      name: "positionName",
      dataIndex: "positionName",
      tableItem: {},
    },
    {
      title: "岗位编码",
      name: "attrs.code",
      dataIndex: "attrs.code",
      searchItem: {},
    },
    {
      title: "岗位编码",
      name: "positionCode",
      dataIndex: "positionCode",
      tableItem: {},
    },
    {
      title: "所属组织",
      name: "positionOrgList",
      dataIndex: "positionOrgList",
      tableItem: {
        render: (text) => {
          return <span>{text?.map(item => item?.name).join(",")}</span>;
        }
      },
    },
  ];
};

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)

            function filter(value) {
              for (let key in value) {
                if (value[key] === undefined) {
                  delete value[key];
                } else if (Object.prototype.toString.call(value[key])==='[object Object]') {
                  filter(value[key])
                }
              }
            }
            filter(value);
            return value
          },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'editorAdd',
                  modalParams: {
                    title: '新增',
                    style: { minWidth: 700 },
                    diy: (e) => {
                      let editorProps = {
                        key: self.state.AddTimestamp,
                        ref: r => r && r.getWrappedInstance(),
                        editorSuccess: () => {
                          self.setState({AddTimestamp: new Date().getTime()})
                        },
                        ...e
                      }
                      return <Editor {...editorProps} />
                    },
                    onCancel: () => {
                      self.setState({ AddTimestamp: new Date().getTime() })
                    },
                    footer: false,
                    width: 680
                  },
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ["edit"],
        rowOperateView: [
          {
            key: 'edit',
            custom: true,
            params: { children: '设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'editorUpdate',
                modalParams: {
                  title: '设置',
                  style: { minWidth: 700 },
                  diy: (e) => {
                    let editorProps = {
                      key: self.state.AddTimestamp,
                      ref: r => r && r.getWrappedInstance(),
                      editorSuccess: () => {
                        self.setState({AddTimestamp: new Date().getTime()})
                      },
                      ...e
                    }
                    return <Editor {...editorProps} />
                  },
                  onCancel: () => {
                    self.setState({ AddTimestamp: new Date().getTime() })
                  },
                  footer: false,
                  width: 680
                },
              }
            }
          }
        ],
        commonOperate: {}
      },
    },
  };
};

const apis = () => {
  return {
    list: {
      path: `${componentName}/positionPageList`,
      payload: {
        key: `${componentName}@positionPageList`,
        apiParams: { },
      },
    },
    export: {
      path: `${componentName}/positionList`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    save: {
      path: `${componentName}/save`,
      payload: {
        key: `${componentName}@save`,
        apiParams: {},
      },
    },
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateConfig, templateConfig };
